import React from "react";
import CreateArticle from "../components/CreateArticle";

const Publish = () => {
  return (
    <>
      <CreateArticle />
      {/* <Login /> */}
    </>
  );
};

export default Publish;
